<template>
  <div class="background_concept">
    <div class="concept_index_text">
      <p class="animate__fadeInUp animate__animated" style="font-size: 24px;margin-bottom: 20px">我们的理念</p>
      <p class="animate__fadeInUp animate__animated animate__delay-1s" style="font-size: 36px;margin-bottom: 20px">寻找价值洼地 赋能新生力量</p>
      <p class="animate__fadeInUp animate__animated animate__delay-2s" style="font-size: 14px;margin-bottom: 0.5em">我们无法预测哪里有价值洼地，但出现洼地的地方，我们会出现，这是勤奋，也是风格。</p>
      <p class="animate__fadeInUp animate__animated animate__delay-2s" style="font-size: 14px">是我们选择了快速生成的洼地，也是新崛起的力量选择了我们。</p>
      <div class="index_down animate__fadeInUp animate__animated animate__delay-3s">
        <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>

  </div>
</template>


<script>
import {DownOutlined} from '@ant-design/icons-vue'
import {reactive} from 'vue'

export default {
  name: 'Concept_index',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 90 / 100,
        behavior: "smooth",
      })
    }
    const show = reactive({
      test: true
    })
    return {next_page, show}
  }
}
</script>


<style scoped>
.background_concept {
  background-image: url("../../../assets/background/concept_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
}

.concept_index_text {
  padding-top: 40vh;
  text-align: left;
  margin-left: 12vw;
  transition: 2s;
}

.index_down {
  padding-top: 2vh;
}

</style>